import fetch from '../utils/fetch'

export function getAuditmemberList (query) {
  return fetch({
    url: '/member/auditmember',
    method: 'get',
    params: query
  })
}
export function getAuditmemberUpdate (params) {
  return fetch({
    url: '/member/auditmember',
    method: 'put',
    data: params
  })
}

export function getAuditmemberLogList (query) {
  return fetch({
    url: '/member/realnameauditloglist',
    method: 'get',
    params: query
  })
}

export function getEpidemicList (query) {
  return fetch({
    url: '/member/epidemicControl',
    method: 'get',
    params: query
  })
}
export function getEpidemicUpdate (params) {
  return fetch({
    url: '/member/epidemicControl',
    method: 'put',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/auditmember.js